import styled from 'styled-components';
import { Link } from 'react-scroll';

const Button = styled(Link)`
  display: flex;
  align-items: center;
  align-content: center;

  color: ${({ dark }) => (dark ? '#010606' : '#fff')};
  font-size: ${({ fontBig }) => (fontBig ? '160px' : '12px')};
  font-weight: 800;
  text-decoration: none;
  text-transform: uppercase;
  white-space: no-wrap;
  cursor: pointer;

  //Button shape & animation
  border-radius: 50px;
  outline: none;
  border: none;
  margin: 10px 0;
  padding: ${({ PaddingBig }) => (PaddingBig ? '14px 48px' : '12px 30px')};
  padding: 0.75rem 1.5rem;
  background-size: 200% auto;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  /* background-image: linear-gradient(
    to right,
    #895cf2 0%,
    #ffabf4 51%,
    #895cf2 100%
  ); */
  background-image: linear-gradient(
    to right,
    #01bf71 0%,
    #92fe9d 51%,
    #01bf71 100%
  );
  transition: var(--transition);

  &:hover {
    transition: var(--transition-hover);
    background-position: right center; /* change the direction of the gradient */
    transform: scale(0.95);
  }
`;

export { Button };
